'use strict'

import ApiClient from './ApiClient'

export default class MbLoginSettingRepository {
  /**
   * モバイルログイン設定の取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/mbloginsettings`)
  }

  /**
   * モバイルログイン設定の更新
   * @param params
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/mbloginsettings`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/MbLoginSettingRepository.js